import {
  Card,
  Divider,
  HStack,
  Spinner,
  Stack,
  Text,
  Wrap,
  WrapItem,
} from '@mybridge/ui';
import { MatrixContext } from 'packages/mybridgev4/context/chat-context';
import { forwardRef, useContext, useEffect, useMemo, useState } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { UserNetworkingActions } from 'v4/components/user-networking-actions';
import { SearchCardSkeleton } from 'v4/snippets/search/search-card-skeleton';
import { NetworkListingNotFound } from '../../../404';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import InfiniteScroll from 'react-infinite-scroll-component';
import MyNetworkSearchInput from 'v4/components/network/network-search-input';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { getUserFullName } from 'v4/lib/commons';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyNetworkThirdDegreeListing = forwardRef(({ ...props }, ref) => {
  const {
    searchQuery,
    setSearchQuery,
    refetchMyThirdDegreeConnections,
    myThirdDegreeConnections,
    myThirdDegreeConnectionsIsFetching,
    myThirdDegreeConnectionsIsLoading,
    userProfileInfo,
    MyThirdDegreeConnectionsFetchNextPage,
    MyThirdDegreeConnectionsHasNextPage,
    myThirdDegreeConnectionsCount,
    myThirdDegreeConnectionsPagingCount,
  } = useContext(MyNetworkContext);
  const { startChatSingle } = useContext(MatrixContext);
  const { t } = useTranslator();
  const { formatNumber } = useNumberFormatter();
  // useEffect(() => {
  //   if (userProfileInfo.id) {
  //     refetchMyThirdDegreeConnections?.();
  //   }
  // }, [userProfileInfo]);
  
  // useEffect(() => {
  //   refetchMyThirdDegreeConnections?.();
    
  //   // Cleanup function to reset searchQuery when component unmounts
  //   return () => {
  //     setSearchQuery('');
  //   };
  // }, []);

  // const [hasInitialized, setHasInitialized] = useState(false);

  /*
  useEffect(() => {
    if (userProfileInfo?.id && !hasInitialized) {
      refetchMyThirdDegreeConnections?.();
      setHasInitialized(true);
    }
  }, [userProfileInfo?.id, hasInitialized, refetchMyThirdDegreeConnections]);

  useEffect(() => {
    if (hasInitialized && userProfileInfo?.id) {
      refetchMyThirdDegreeConnections?.();
    }
  }, [searchQuery, hasInitialized, userProfileInfo?.id, refetchMyThirdDegreeConnections]);

  // Cleanup
  useEffect(() => {
    return () => {
      setSearchQuery('');
      setHasInitialized(false);
    };
  }, [setSearchQuery]);
  */

  // Cleanup
  useEffect(() => {
    return () => {
      setSearchQuery('');
    };
  }, [setSearchQuery]);



  // Filter connections based on searchQuery
  const filteredThirdDegreeList = useMemo(() => {
    let filtered = myThirdDegreeConnections || [];
    if (searchQuery?.length > 0) {
      filtered = filtered.filter((user) => {
        const name = getUserFullName(user)?.toLowerCase?.();
        return name?.includes(searchQuery?.toLowerCase());
      });
    }
    return filtered;
  }, [myThirdDegreeConnections, searchQuery]);

  // Check if we have connections but no search results
  const hasConnections = (myThirdDegreeConnections?.length > 0);
  const hasNoSearchResults = hasConnections && searchQuery?.length > 0 && filteredThirdDegreeList?.length === 0;

  return (
    <>
      {myThirdDegreeConnectionsIsLoading ? (
        <HStack w="100%" justifyContent="center">
          <Spinner />
        </HStack>
      ) : (
        <>
          {/* Show header with count and search input if we have connections or if searching with no results */}
          {(hasConnections || hasNoSearchResults) && (
            <HStack
              w="100%"
              justifyContent="space-between"
              alignItems="center"
              px={3}
            >
              <Text fontSize={['14px', '16px']} color="#868585" visibility={searchQuery?.length > 0 ? 'hidden' : 'visible'}>
                {formatNumber(myThirdDegreeConnectionsCount)}{' '}
                {!isMobile 
                  ? myThirdDegreeConnectionsCount === 1 
                    ? t('profile.connection') || 'Connection' 
                    : t('profile.connections') || 'Connections' 
                  : t('profileNetwork.thirdDegreeConnections') || '3rd Degree Connections'}
              </Text>
              {!isMobile && <MyNetworkSearchInput searchType="myThirdDegree" />}
            </HStack>
          )}
          
          {isMobile && <Divider my={4} />}
          
          {/* Show connections if we have search results */}
          {filteredThirdDegreeList?.length > 0 ? (
            <InfiniteScroll
              dataLength={myThirdDegreeConnectionsPagingCount}
              next={MyThirdDegreeConnectionsFetchNextPage}
              hasMore={!!MyThirdDegreeConnectionsHasNextPage}
              loader={myThirdDegreeConnectionsIsFetching?
                <HStack pb={5} justifyContent="center" w="100%">
                  <Spinner />
                </HStack>:""
              }
              scrollableTarget="myThirdDegreeConnectionsContainer"
            >
              <Wrap id="myThirdDegreeConnectionsContainer"
                spacing={2}
                p={3}
                pt="20px" 
                overflow="auto"
                height="75vh"
                sx={{
                  scrollbarWidth: 'none', 
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}
              >
                {filteredThirdDegreeList?.map?.((cu, cuIndex) => (
                  <WrapItem
                    key={cuIndex}
                    maxW={['49%', '30%', '190px']}
                    flexGrow={['1', '1', 0]}
                    flexShrink={['1', '1', 0]}
                    flex="auto"
                  >
                    <MyNetworkUserCardBordered
                      key={cuIndex}
                      user={cu}
                      actions={
                        <UserNetworkingActions
                          user={cu}
                          justifyContent="center"
                          showHandshakeOnly
                        />
                      }
                    />
                  </WrapItem>
                ))}
              </Wrap>
            </InfiniteScroll>
          ) : (
            <>
              {/* Show "No users found" message if searching with no results */}
              {hasNoSearchResults ? (
                <HStack justifyContent="center">
                  <Stack alignItems="center">
                    <NetworkListingNotFound />
                    <Text>{t('scheduling.noUserFound') || "No User Found"}</Text>
                  </Stack>
                </HStack>
              ) : (
                /* Show default empty state if no connections at all */
                !hasConnections && (
                  <HStack justifyContent="center">
                    <Stack alignItems="center">
                      <NetworkListingNotFound />
                      <Text>{t('myMessages.noThirdDegreeConnection')}</Text>
                    </Stack>
                  </HStack>
                )
              )}
            </>
          )}
          
          {isMobile && <Divider my={4} />}
        </>
      )}
    </>
  );
});
